import { Group, Stack, Text } from '@mantine/core'

import NextBaseImage from '@/components/basic/BaseImage'
import PriceChange from '@/components/PriceChange'
import { useI18nRouter } from '@/i18n/navigation'
import { CoinCategory } from '@/services/category'

import styles from '../styles.module.css'

export default function TopCoinsColumn({ category }: { category: CoinCategory }) {
  const { highlighted_coins: topCoins } = category
  const router = useI18nRouter()

  return (
    <Stack gap={12} align="flex-end">
      {topCoins?.slice(0, 2).map(coin => (
        <Group
          key={coin.id}
          gap={8}
          wrap="nowrap"
          justify="flex-end"
          className={styles.topCoinsItem}
          role="button"
          tabIndex={0}
          onClick={() => {
            router.push(`/${coin.slug}`)
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              router.push(`/${coin.slug}`)
            }
          }}
        >
          {coin.icon_image_url && (
            <NextBaseImage
              src={coin.icon_image_url}
              alt={coin.name}
              className={styles.coinImage}
              width={'20px'}
              height={'20px'}
            />
          )}
          <Text variant="body1" truncate className={styles.coinName}>
            {coin.name}
          </Text>
          <PriceChange w={80} value={Number(coin.percent_change_24h_native) * 0.01} />
        </Group>
      ))}
    </Stack>
  )
}
